<template>
  <VApp>
    <VContainer
      fluid
    >
      <VLayout
        row
        wrap
        align-center
        justify-center
      >
        <VFlex xs12>
          <slot name="table" />
        </VFlex>
        <VFlex xs12>
          <div
            v-if="isFetchingMore"
            class="text-xs-center"
          >
            <VProgressCircular
              :size="50"
              center
              color="primary"
              indeterminate
            />
          </div>
        </VFlex>
      </VLayout>
      <NetworkSnackBar />
      <ProgressDialogCard
        :description="statusMessage"
        :dialog="loadingStatus"
        indeterminate
      />
    </VContainer>
  </VApp>
</template>

<script>
import CONTACTS_WITH_WORK_QUERY from '@/backend/graphql/contact/ContactsWithWork.gql'
import ACTIVE_CONTACTS_BY_NUMBER from '@/backend/graphql/contact/ActiveContactsByNumber.gql'
import { NetworkStatus } from 'apollo-client/core/networkStatus'
import ProgressDialogCard from '@/components/ProgressDialogCard'
import NetworkSnackBar from '../components/NetworkSnackBar'

export default {
  name: 'ListViewPage',
  components: { NetworkSnackBar, ProgressDialogCard },
  props: {
    getGqlQuery: {
      type: Object,
      default: function () {
        return CONTACTS_WITH_WORK_QUERY
      }
    },
    updateGqlQuery: {
      type: Object,
      default: function () {
        return ACTIVE_CONTACTS_BY_NUMBER
      }
    },
    getCurrentTableData: {
      type: Function,
      default: function (data) {
        return []
      }
    },
    getQueryVariables: {
      type: Function,
      default: function () {
        return {}
      }
    },
    updateQueryVariables: {
      type: Function,
      default: function () {
        return null
      }
    },
    updateContextVariable: {
      type: Function,
      default: function (key, value) {
        if (this.hasOwnProperty(key)) {
          this[key] = value
        }
      }
    },
    getLoadingStatus: {
      type: Function,
      default: function () {}
    },
    setLoadingStatus: {
      type: Function,
      default: function (val) {}
    },
    getStatusMessage: {
      type: Function,
      default: function () {}
    },
    setStatusMessage: {
      type: Function,
      default: function (message) {}
    },
    parseGetData: {
      type: Function,
      default: function (data) {}
    },
    parseUpdateData: {
      type: Function,
      default: function (data) {}
    },
    fetchingMore: {
      type: Boolean,
      default: false
    },
    runningUpdateQuery: {
      type: Boolean,
      default: false
    },
    updateQueryDisabled: {
      type: Boolean,
      default: true
    },
    clearData: {
      type: Function,
      default: function () {}
    }
  },
  data: function () {
    return {
      isFetchingMore: false
    }
  },
  computed: {
    loadingStatus: {
      get: function () {
        return this.getLoadingStatus()
      },
      set: function (val) {
        this.setLoadingStatus(val)
      }
    },
    statusMessage: {
      get: function () {
        return this.getStatusMessage()
      },
      set: function (message) {
        this.setStatusMessage(message)
      }
    }
  },
  watch: {
    fetchingMore: function () {
      this.isFetchingMore = this.fetchingMore
      if (this.isFetchingMore) {
        this.$apollo.skipAll = true
        this.updateContextVariable('offset', this.getCurrentTableData().length)
        this.$apollo.queries.getTableItems.skip = false
        this.$apollo.queries.getTableItems.refetch()
      }
    },
    runningUpdateQuery: function (val) {
      if (this.updateQueryDisabled) return
      if (val) {
        this.$apollo.skipAll = true
        this.$apollo.queries.updateTableItems.skip = false
        this.$apollo.queries.updateTableItems.refetch()
      }
    }
  },
  beforeDestroy () {
    this.clearData()
  },
  apollo: {
    getTableItems: {
      query () {
        return this.getGqlQuery
      },
      variables () {
        return this.getQueryVariables()
      },
      manual: true,
      result ({ data, loading, networkStatus }) {
        this.setQueryStatus(networkStatus)
        if (!loading && networkStatus !== NetworkStatus.error) {
          this.parseGetData(data)
        }
      },
      error (error) {
        this.loadingStatus = false
        this.$store.dispatch('alert/error', error.message)
      },
      skip: false
    },
    updateTableItems: {
      query () {
        return this.updateGqlQuery
      },
      variables () {
        return this.updateQueryVariables()
      },
      manual: true,
      result ({ data, loading, networkStatus }) {
        // this.setQueryStatus(networkStatus)
        if (!loading && networkStatus !== NetworkStatus.error) {
          this.parseUpdateData(data)
        }
      },
      error (error) {
        this.loadingStatus = false
        this.$store.dispatch('alert/error', error.message)
      },
      skip () {
        return this.updateQueryDisabled || !this.runningUpdateQuery
      }
    }
  },
  methods: {
    setQueryStatus (networkStatus) {
      switch (networkStatus) {
        case NetworkStatus.loading:
          this.loadingStatus = true
          break
        case NetworkStatus.setVariables:
          this.loadingStatus = true
          break
        case NetworkStatus.ready:
          break
        case NetworkStatus.poll:
          break
        case NetworkStatus.error:
          this.loadingStatus = false
          break
        default:
          break
      }
    }
  }
}
</script>

<style scoped>

</style>
